// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";

var placeholderShimmer = Curry._1(Css.keyframes, {
      hd: [
        0,
        {
          hd: Css.backgroundPositions({
                hd: Css.px(-800),
                tl: {
                  hd: Css.px(0),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      ],
      tl: {
        hd: [
          100,
          {
            hd: Css.backgroundPositions({
                  hd: Css.px(800),
                  tl: {
                    hd: Css.px(0),
                    tl: /* [] */0
                  }
                }),
            tl: /* [] */0
          }
        ],
        tl: /* [] */0
      }
    });

var shimmerBox_0 = Css.background(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey30_nohashtag));

var shimmerBox_1 = {
  hd: Css.backgroundImage({
        NAME: "linearGradient",
        VAL: [
          Css.deg(90),
          [
            [
              Css.px(0),
              Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey30_nohashtag)
            ],
            [
              Css.px(60),
              Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey40_nohashtag)
            ],
            [
              Css.px(100),
              Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey30_nohashtag)
            ]
          ]
        ]
      }),
  tl: {
    hd: Css.backgroundSize({
          NAME: "size",
          VAL: [
            Css.px(800),
            Css.px(800)
          ]
        }),
    tl: {
      hd: Css.backgroundRepeat("noRepeat"),
      tl: {
        hd: Css.animationDuration({
              NAME: "ms",
              VAL: 1000
            }),
        tl: {
          hd: Css.animationFillMode(Css.forwards),
          tl: {
            hd: Css.animationName(placeholderShimmer),
            tl: {
              hd: Css.animationIterationCount("infinite"),
              tl: {
                hd: Css.animationTimingFunction(Css.linear),
                tl: /* [] */0
              }
            }
          }
        }
      }
    }
  }
};

var shimmerBox = {
  hd: shimmerBox_0,
  tl: shimmerBox_1
};

var invertedShimmerBox = Belt_List.concat({
      hd: Css.backgroundImage({
            NAME: "linearGradient",
            VAL: [
              Css.deg(90),
              [
                [
                  Css.px(0),
                  Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)
                ],
                [
                  Css.px(60),
                  Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey40_nohashtag)
                ],
                [
                  Css.px(100),
                  Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)
                ]
              ]
            ]
          }),
      tl: {
        hd: Css.background(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)),
        tl: /* [] */0
      }
    }, shimmerBox);

var ShimmerStyling = {
  placeholderShimmer: placeholderShimmer,
  shimmerBox: shimmerBox,
  invertedShimmerBox: invertedShimmerBox
};

function LoadingCard$CardContainer(props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.borderRadius(Css.px(1)),
                    tl: {
                      hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                      tl: {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.flexDirection("column"),
                          tl: {
                            hd: Css.flexWrap("wrap"),
                            tl: {
                              hd: Css.justifyContent("spaceBetween"),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  })
            }, props.children);
}

var CardContainer = {
  make: LoadingCard$CardContainer
};

function LoadingCard$GridComponent(props) {
  var inverted = props.inverted;
  var placeholderWidth = props.placeholderWidth;
  var placeholderHeight = props.placeholderHeight;
  if (inverted !== undefined && inverted === true) {
    return React.createElement("div", {
                className: Curry._1(Css.style, Belt_List.concat({
                          hd: Css.height(placeholderHeight),
                          tl: {
                            hd: Css.width(placeholderWidth),
                            tl: /* [] */0
                          }
                        }, invertedShimmerBox))
              });
  }
  return React.createElement("div", {
              className: Curry._1(Css.style, Belt_List.concat({
                        hd: Css.height(placeholderHeight),
                        tl: {
                          hd: Css.width(placeholderWidth),
                          tl: /* [] */0
                        }
                      }, shimmerBox))
            });
}

var GridComponent = {
  make: LoadingCard$GridComponent
};

function LoadingCard$ConfirmAccount(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement(LoadingCard$CardContainer, {
              children: React.createElement(PropSpread$LiveRoom.make, {
                    data: {
                      hd: {
                        TAG: /* TestId */1,
                        _0: "SelectAccountLoading"
                      },
                      tl: /* [] */0
                    },
                    children: React.createElement("div", {
                          className: Curry._1(Css.merge, {
                                hd: Curry._1(Css.style, {
                                      hd: Css.display("grid"),
                                      tl: {
                                        hd: Css.alignItems("flexStart"),
                                        tl: {
                                          hd: Css.gridTemplateColumns({
                                                hd: Css.pct(100),
                                                tl: /* [] */0
                                              }),
                                          tl: {
                                            hd: Css.gridTemplateRows({
                                                  hd: Css.px(120),
                                                  tl: {
                                                    hd: Css.px(32),
                                                    tl: {
                                                      hd: Css.px(32),
                                                      tl: {
                                                        hd: Css.px(32),
                                                        tl: {
                                                          hd: Css.px(32),
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    }
                                                  }
                                                }),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }),
                                tl: {
                                  hd: className$1,
                                  tl: /* [] */0
                                }
                              })
                        }, React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 1),
                                    tl: {
                                      hd: Css.gridRow(1, 1),
                                      tl: /* [] */0
                                    }
                                  })
                            }, React.createElement(LoadingCard$GridComponent, {
                                  placeholderHeight: Css.px(80),
                                  placeholderWidth: Css.pct(100)
                                })), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 1),
                                    tl: {
                                      hd: Css.gridRow(2, 2),
                                      tl: /* [] */0
                                    }
                                  })
                            }, React.createElement(LoadingCard$GridComponent, {
                                  placeholderHeight: Css.px(18),
                                  placeholderWidth: Css.pct(100)
                                })), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 1),
                                    tl: {
                                      hd: Css.gridRow(3, 3),
                                      tl: /* [] */0
                                    }
                                  })
                            }, React.createElement(LoadingCard$GridComponent, {
                                  placeholderHeight: Css.px(18),
                                  placeholderWidth: Css.pct(100)
                                })), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 1),
                                    tl: {
                                      hd: Css.gridRow(4, 4),
                                      tl: /* [] */0
                                    }
                                  })
                            }, React.createElement(LoadingCard$GridComponent, {
                                  placeholderHeight: Css.px(18),
                                  placeholderWidth: Css.pct(100)
                                })), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 1),
                                    tl: {
                                      hd: Css.gridRow(5, 5),
                                      tl: /* [] */0
                                    }
                                  })
                            }, React.createElement(LoadingCard$GridComponent, {
                                  placeholderHeight: Css.px(18),
                                  placeholderWidth: Css.pct(100)
                                })))
                  })
            });
}

var ConfirmAccount = {
  make: LoadingCard$ConfirmAccount
};

function LoadingCard$InfoModal(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement(LoadingCard$CardContainer, {
              children: React.createElement("div", {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.display("grid"),
                                tl: {
                                  hd: Css.alignItems("flexStart"),
                                  tl: {
                                    hd: Css.gridTemplateColumns({
                                          hd: Css.pct(100),
                                          tl: /* [] */0
                                        }),
                                    tl: {
                                      hd: Css.gridTemplateRows({
                                            hd: Css.px(120),
                                            tl: {
                                              hd: Css.px(32),
                                              tl: {
                                                hd: Css.px(32),
                                                tl: {
                                                  hd: Css.px(32),
                                                  tl: {
                                                    hd: Css.px(32),
                                                    tl: {
                                                      hd: Css.px(32),
                                                      tl: /* [] */0
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }),
                          tl: {
                            hd: className$1,
                            tl: /* [] */0
                          }
                        })
                  }, React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(1, 1),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$GridComponent, {
                            placeholderHeight: Css.px(80),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(2, 2),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$GridComponent, {
                            placeholderHeight: Css.px(24),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(3, 3),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$GridComponent, {
                            placeholderHeight: Css.px(24),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(4, 4),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$GridComponent, {
                            placeholderHeight: Css.px(24),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(5, 5),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$GridComponent, {
                            placeholderHeight: Css.px(24),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(6, 6),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$GridComponent, {
                            placeholderHeight: Css.px(24),
                            placeholderWidth: Css.pct(70)
                          })))
            });
}

var InfoModal = {
  make: LoadingCard$InfoModal
};

export {
  ShimmerStyling ,
  CardContainer ,
  GridComponent ,
  ConfirmAccount ,
  InfoModal ,
}
/* placeholderShimmer Not a pure module */
